import React, {useContext, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Routes, Route, useLocation } from 'react-router-dom';

import { AppContext } from '../../context/app-context';
import { SummaryTabIndex, MainTabPanelIndex } from '../../model/constants';

import SummaryTab from '../tabs/SummaryTab';
import MapTab from '../tabs/MapTab';
import EventsTab from '../tabs/EventsTab';
import HistoryTab from '../tabs/HistoryTab';
import AdminTab from '../tabs/AdminTab';
import EquipsTab from '../tabs/EquipsTab';
import ControlTab from '../tabs/ControlTab';
import TunerTab from '../tabs/TunerTab';

export default function MainInfoComponent() {
  console.log("render MainInfoComponent");
  const [appState, appDispatch] = useContext(AppContext);

  const tabPanelIndex = appState.currentTab?.panel ?? MainTabPanelIndex;
  const location = useLocation();

   useEffect(() => {
    if (location.state?.panelIndex !== undefined && location.state?.tabIndex !== undefined && (location.state?.tabIndex !== appState.currentTab?.tab ||  location.state?.panelIndex !== appState.currentTab?.panel))
    {
        appDispatch({ type: 'SETTAB', payload: {tab: location.state?.tabIndex, panel: location.state?.panelIndex} });
    } 

   }, [location]);

   return (
    <div name="divMainInfoComponent">
      <Routes>
        <Route path="summary/*" element={<SummaryTab panel={tabPanelIndex}></SummaryTab>}/>
        <Route path="equip/*" element={<EquipsTab></EquipsTab>} />  
        <Route path="map/*" element={<MapTab></MapTab>}/>
        <Route path="events/*" element={<EventsTab></EventsTab>} />  
        {/*<Route path="history/*" element={<HistoryTab></HistoryTab>}/>*/}
        <Route path="control/*" element={<ControlTab panel={tabPanelIndex}></ControlTab>} />  
        <Route path="admin/*" element={<AdminTab panel={tabPanelIndex}></AdminTab>}/>
        <Route path="detTuner/*" element={<TunerTab panel={tabPanelIndex}></TunerTab>} />  
  </Routes>
</div>
      
  );
}